import {EditorView} from "prosemirror-view";
import {EditorState, Transaction} from "prosemirror-state";

import {MentionType} from "../../schema/nodes/mention";


import {replaceTextRangeWithNode} from "./utils";


import {schema} from "../../config/schema";


export interface InsertMentionParams {
    type: MentionType;
    targetId: string;
    textInput: string;
    nodePos: number;
}

export const insertMention = (state: EditorState, dispatch?: (tr: Transaction) => void, view?: EditorView, additionalParams?: InsertMentionParams) => {
    const node = schema.nodes.mention.create({
        type: additionalParams?.type,
        targetId: additionalParams?.targetId,
    });
    const tr = replaceTextRangeWithNode(state, additionalParams!.nodePos, additionalParams!.nodePos + additionalParams!.textInput.length + 1, node);
    if (tr !== state.tr) {
        dispatch && dispatch(tr);
        view?.focus();
        return true;
    }
    return false;
}
